import { AccountCircleOutlined, Logout } from '@mui/icons-material';
import {
  Box,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import { useLazyLogoutQuery } from 'api/oauth/oauth';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectEmail } from 'redux/user/user.selectors';

const UserMenu = () => {
  const { t } = useTranslation();
  const [trigger] = useLazyLogoutQuery();
  const logout = () => trigger({});
  const [anchorEl, setAnchorEl] = useState(null);
  const email = useSelector(selectEmail);

  const handleMenu = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <IconButton
        size="large"
        aria-label={t('UserMenu.menuButton.ariaLabel')}
        aria-controls="UserMenu.Menu"
        aria-haspopup="true"
        onClick={handleMenu}
        data-testid="UserMenu.IconButton"
      >
        <AccountCircleOutlined />
      </IconButton>
      <Menu
        id="UserMenu.Menu"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{ '& .MuiPaper-root': { maxWidth: 200 } }}
        slotProps={{
          list: { 'data-testid': 'UserMenu.MenuList' } as any,
        }}
      >
        <Box component="li" overflow="hidden" fontSize={1} p={1} pt={0}>
          <Typography variant="subtitle2">{t('UserMenu.userText')}</Typography>
          <Box textOverflow="ellipsis" fontWeight="bold">
            <Typography variant="subtitle2">{email}</Typography>
          </Box>
        </Box>
        <Divider />
        <MenuItem onClick={logout} data-testid="UserMenu.MenuItem.Logout">
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          {t('UserMenu.menuItem.logout.label')}
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default UserMenu;
